import revisions from "./elevateLearnerCopy.json";

const copy: Record<string, string> = revisions.copy;
const promptSentences: Record<string, string> = revisions.promptSentences;

// Audience-only editorial pass. Exact replacements keep the source curriculum
// available to Longhand and Council consumers. Evidence and references stay intact.
const preservedFields = new Set([
  "id", "sourceIds", "sourceUrl", "sourceLabel", "href", "url", "image", "imageAlt",
  "showcaseId", "showcaseIds", "checkpointId", "sampleInput", "outputs", "artifact",
  "quote", "platform", "provider", "applicationFunctions", "function", "path",
]);

export const reviseElevateText = (text: string, prompt = false): string => {
  let revised = copy[text] ?? text;
  if (prompt) {
    for (const [before, after] of Object.entries(promptSentences)) {
      revised = revised.split(before).join(after);
    }
  }
  return revised.split("ChatGPT or Claude").join("Claude or ChatGPT");
};

export const reviseElevateLearnerCopy = <T,>(value: T, field = ""): T => {
  if (preservedFields.has(field)) return value;
  if (typeof value === "string") return reviseElevateText(value, field === "prompt" || field === "value") as T;
  if (Array.isArray(value)) return value.map(item => reviseElevateLearnerCopy(item, field)) as T;
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, reviseElevateLearnerCopy(item, key)])) as T;
  }
  return value;
};
